import { createServerFn } from "@tanstack/react-start";

import { cmsRegistry } from "./cmsRegistry";
import type { PriceList } from "./priceLists";
import { contentSource } from "./source";

const resolve = cmsRegistry<PriceList>({
  // Through `contentSource()`, whose dynamic import keeps the CMS client out
  // of the client chunk, see `content/landing/source.ts`.
  load: async () => (await contentSource()).loadPriceLists(),
  keyOf: (list) => list.id,
});

/**
 * A price list by its document id, for a page the code draws: read once per
 * process in production, as the page registries are, so the seventy-five
 * country pages share one read. A list the CMS does not hold is null. The
 * dashboard's figures go into the list asked for, and only that one
 * (`dashboardPrices.ts`, imported here for the same reason as the CMS).
 */
export const priceListCms = createServerFn({ method: "GET" })
  .inputValidator((id: unknown): string => String(id ?? ""))
  .handler(async ({ data }): Promise<PriceList | null> => {
    const list = await resolve(data);
    if (!list) return null;
    const { livePriceList } = await import("./dashboardPrices");
    return livePriceList(list);
  });
